import { sugerencias } from "../../components/generico/utils/UrlAPI";
import axios from "axios";
import authService from "../login/auth.service";

class SugerenciasService {

    async enviarSugerencias(data) {

        data = {
            ...data,
            idPersona: authService.getSocio().idPersona
        }

        var config = {
            method: "post",
            url: sugerencias + "sugerencias/guardar-sugerencia",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken()
            },
            data,
        };

        return await axios(config);
    }

    async obtenerModulos() {
        var config = {
            method: "get",
            url: sugerencias + "sugerencias/lista-modulos",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken()
            },
        };

        return await axios(config);
    }

    async obtenerSectores() {
        var config = {
            method: "get",
            url: sugerencias + "sugerencias/lista-sectores",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken()
            },
        };

        return await axios(config);
    }

    async obtenerParametros() {
        var config = {
            method: "get",
            url: sugerencias + "sugerencias/lista-parametros",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + authService.getCurrentToken()
            },
        };

        return await axios(config);
    }

}
export default new SugerenciasService();
